<template> 
    <header class="mui-bar mui-bar-nav mui-header mui-tip-header">
        <a class="mui-icon mui-icon-calculates mui-pull-left" @click="calculate();"></a>
        <h1 class="mui-title">时间价值</h1>
        <a class="mui-icon mui-icon-warn mui-pull-right" v-bind:class="{'mui-grow-tip': message}" v-link="{path: '/news'}">
            <em v-if="message" v-html="message"></em>
        </a>
    </header>
    <div class="mui-home" id="Container">
        <!-- <div class="mui-public-tips" v-if="publicTips" transition="mui-collapse-fade">
            <div class="mui-tips-row">
                <i class="mui-icon mui-icon-notices"></i>
                <a href="javascript:;" @click="closeNotice()" v-link="{path: '/recharge'}">
                    <p>关于转账充值方式调整的通知</p>
                </a>
                <i class="mui-icon mui-icon-close" @click="closeNotice()"></i>
            </div>
        </div> -->
        <div id="slider" class="mui-slider mui-banner-slider">
            <div class="mui-slider-group  mui-slider-loop">
                <div class="mui-slider-item" v-for="banner in bannerList" v-bind:class="[{'mui-slider-item-duplicate': banner.loop, 'BannerTarget': banner.window && banner.window.view}]" v-show="banner.weixin">
                    <a v-if="banner.window" href="{{banner.href}}" title="{{banner.windowtitle}}" fullscreen="{{banner.fullscreen}}">
                        <img v-bind:src="banner.image">
                        <div class="tv-banner-text"><span>广告</span>网贷有风险，出借需谨慎</div>
                    </a>
                    <a v-else v-link="{path: banner.href}">
                        <img v-bind:src="banner.image">
                        <div class="tv-banner-text"><span>广告</span>网贷有风险，出借需谨慎</div>
                    </a>
                </div>
            </div>
            <div class="mui-slider-indicator">
                <div class="mui-indicator" v-for="indicator in indicatorLength" v-bind:class="{'mui-active': $index == 0}"></div>
            </div>
        </div>
        <!--<ul class="mui-table-view mui-hairline-table-view mui-notice-row">
            <li class="mui-table-view-cell" v-for="item in notice">
                <a class="mui-navigate-right mui-ellipsis" v-link="{ path: '/index/notice'}" external><i class="mui-icon mui-icon-notices mui-txt-blue"></i><font v-html="item.newsTitle"></font><span v-html="item.newsTime.substring(0,11)"></span></a>
            </li>
        </ul>-->
        <ul class="mui-table-view mui-grid-view mui-grid-9 mui-index-grid">
            <li class="mui-table-view-cell mui-media mui-col-xs-3 mui-col-sm-3">
                <a v-link="{ path: '/index/intro', query:{ind: 1}}">
                    <span><i class="mui-icons mui-icons-index1"></i></span>
                    <div class="mui-media-body">合规透明</div>
                </a>
            </li>
            <li class="mui-table-view-cell mui-media mui-col-xs-3 mui-col-sm-3">
                <a v-link="{ path: '/index/intro', query:{ind: 2}}">
                    <span><i class="mui-icons mui-icons-index2"></i></span>
                    <div class="mui-media-body">小额分散</div>
                </a>
            </li>
            <li class="mui-table-view-cell mui-media mui-col-xs-3 mui-col-sm-3">
                <a v-link="{ path: '/index/intro', query:{ind: 3}}">
                    <span><i class="mui-icons mui-icons-index3"></i></span>
                    <div class="mui-media-body">债转便捷</div>
                </a>
            </li>
            <li class="mui-table-view-cell mui-media mui-col-xs-3 mui-col-sm-3">
                <a v-link="{ path: '/index/intro', query:{ind: 4}}">
                    <span><i class="mui-icons mui-icons-index4"></i></span>
                    <div class="mui-media-body">按秒计息</div>
                </a>
            </li>
        </ul>

        <div class="mui-index-jxbank">
            <a v-link="{path: '/index/bankdeposit'}">
                <i></i>
                <h3>江西银行资金存管</h3>
                <p>2016年11月全面接入银行资金存管</p>
            </a>
        </div>

        <div class="mui-rate-row mui-index-rate">
            <div class="mui-rate-change">
                <!-- <h4 class="mui-icon-title"><div class="mui-icon mui-icon-diamond"><i class="mui-icon mui-icon-square2"></i></div><font v-if="session">投资立享</font><font v-else>新手福利</font> <a v-link="{path: '/products'}" class="mui-pull-right">查看债权<b class="mui-icon mui-icon-right"></b></a></h4> -->
                <div class="mui-index-title">
                    <div class="mui-types-titles" v-bind:class="{'mui-types-titles1': !session}"><font v-if="session">出借立享</font><font v-else>新手福利，注册即送8000元体验金</font></div>
                </div>
                <div class="mui-user-example">
                    <div class="mui-user-rate mui-clearfix">
                        <div v-if="session">
                            <h3 class="mui-rate-list" v-bind:class="{'mui-center': !userAssets.currentInterestInc }"><p>近期出借利率</p>5.0%</h3>
                            <div v-if="userAssets.currentInterestInc">
                                <h3 class="mui-rate-plus"><span></span></h3>
                                <h3 class="mui-rate-list"><p>加息券</p><font v-html="(userAssets.currentInterestInc*100).toFixed(1)">1</font>%</h3>
                            </div>
                        </div>
                        <div v-else>
                            <h3 class="mui-rate-list"><p>近期出借利率</p>5.0%</h3>
                            <h3 class="mui-rate-plus"><span></span></h3>
                            <h3 class="mui-rate-list"><p>新手专享加息</p>3.8%</h3>
                        </div>
                    </div>
                    <ul class="mui-user-feature mui-clearfix">
                        <li><i class="icons1"></i>最低出借金额1元</li>
                        <li><i class="icons2"></i>出借成功即起息</li>
                        <li><i class="icons3"></i>操作简单可转让</li>
                    </ul>
                </div>
                <div v-if="session" style="background:none; padding: 0.8rem 0.65rem; margin: 0 4%; max-height: 3.8rem">
                    <a class="mui-btn-block" v-link="{path: '/retreat'}">我的账户</a>
                </div>
                <div v-else class="mui-actions mui-index-actions mui-clearfix" style="background:none;">
                    <a class="mui-action-btn mui-white-content" v-link="{path: '/register'}">注册</a>
                    <a class="mui-fill-btn" v-link="{path: '/login'}">登录</a>
                </div>
                <!-- <p class="mui-index-guide"><span>上滑查看更多</span></p> -->
            </div>
        </div>
        
        <div class="mui-index-more">
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-timer" style="border-radius: inherit;"></i>什么是时间价值网</h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex1.jpg" style="width:100%;" alt="">
                    </div>
                    时间价值网是深圳市时间价值信息技术股份公司旗下运营的科技金融平台，由A股上市公司汇川技术（300124.SZ）控股股东汇川投资及前海安星资产战略入股。
                    <br>
                </div>
            </div>
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-doctor" style="background-position:0 -1.2rem ;border-radius: inherit;"></i>时间价值网创始团队<a class="mui-lookmore" v-link="{path: '/index/team'}">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb">
                    <!-- <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex2.jpg" style="width:100%;"  alt="">
                    </div> -->
                    时间价值网创始团队均毕业于北京大学，其中董事长庄舟浩、CEO王炜、CRO蒋牧人毕业于北大法学院，从事投资银行业务近十年，具备专业法律素养和金融产品设计能力；而CTO黎元春毕业于北大地球与空间科学学院，具备15年IT系统架构与实现经验。
                    <br>
                   <!-- <a v-link="{path: '/index/team'}">查看更多人物风采<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-building"  style="background-position:0 -2.7rem ;border-radius: inherit;"></i>股东背景<a class="mui-lookmore" v-link="{path: '/index/holder'}">查看更多</a> </h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex3.jpg"  style="width:100%;" alt="">
                    </div>
                    2016年2月，时间价值网获得汇川技术（300124.SZ）控股股东汇川投资、前海安星资产2000万A轮战略投资。
                    <br>
                    <!--<a v-link="{path: '/index/holder'}">查看更多介绍<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-recommend"  style="background-position:0 -4.28rem ;border-radius: inherit;"></i>平台优势<a class="mui-lookmore" v-link="{path: '/index/product'}">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex4.jpg" style="width:100%;" alt="">
                    </div>
                    按秒计息、操作简单的出借工具是您出借组合中必不可少的出借利器。 
                    <!--<a v-link="{path: '/index/product'}">查看更多介绍<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>
            
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-shield"  style="background-position:0 -5.86rem ;border-radius: inherit;"></i>“SaaS+金融”系统打造真实债权<a class="mui-lookmore" v-link="{path: '/find/aboutus',query:{'active':'saas'}}">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex5.jpg" style="width:100%;"  alt="">
                    </div>
                    时间价值网利用自主研发的“SaaS+金融”模块系统，通过严格的风险监控系统对融资主体的业务流程进行节点监控，以保证债权具有业务真实清晰、流程实时监控、债权小额分散等优点。 
                    <!--<a v-link="{path: '/index/security',query:{'active':'saas'}}">查看更多介绍<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>

            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-securitys"  style="background-position:0 -7.2rem ;background-size: 1.36rem;border-radius: inherit;"></i>风险提示<a class="mui-lookmore" v-link="{path: '/find/risk'}">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex6.jpg" style="width:100%;" alt="">
                    </div>
                    任何出借都伴随风险，我们希望您能充分了解和评估出借的相关风险，根据您的风险承受能力谨慎作出出借决策。
                    <br>
                    <!--<a v-link="{path: '/find/risk'}">查看更多介绍<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>
            
            <!--出借人教育-->
            
            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-securitys"  style="background-position:0 -10rem ;background-size: 1.36rem;border-radius: inherit;"></i>出借人教育<a class="mui-lookmore" v-link="{path: '/find/education'}">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb">
                    <div class="mui-text-center">
                        <img src="/wealthm/static/images/index/timeindex7.jpg" style="width:100%;" alt="">
                    </div>
                    时间价值网根据监管规定开立专门的出借人教育专栏，为出借人提供风险教育，并普及相关法律法规知识，供平台用户参考学习。
                    <br>
                    <!--<a v-link="{path: '/find/risk'}">查看更多介绍<i class="mui-icon mui-icon-right"></i></a>-->
                </div>
            </div>

            <div class="mui-more-row mui-more-rowb">
                <h4 class="mui-icon-title mui-icon-titleb"><i class="mui-new-icon mui-icon mui-icon-operates"  style="background-position:0 -8.95rem ;border-radius: inherit;"></i>稳健运营<a class="mui-lookmore" href="/wealthm/information/index.html" onclick="mui.WebView.Screenfull(this); return false;">查看更多</a></h4>
                <div class="mui-index-desc mui-index-descb" style="line-height: inherit;">
                    <div class="mui-index-trading">
                        <span class="mui-line-point"><b class="left"></b><b  class="right"></b><i class="left"></i><i class="right"></i>已安全运营 <font v-html="totalDays"></font> 天</span>
                        <ul>
                            <li>
                                <em>累计成交金额（元）</em>
                                <span><i v-html="totalCharge"></i></span>
                            </li>
                            <li>
                                <em>累计赚取收益（元）</em>
                                <span><i v-html="totalProfit"></i></span>
                            </li>
                        </ul>
                    </div>
            <ul class="mui-find-grid-9 mui-table-view mui-grid-view mui-grid-9 mui-grid-icons">
                <li class="mui-table-view-cell mui-media mui-col-xs-4 mui-col-sm-3">
                <a v-link="{ path: '/find/info'}" external>
                    <div class="mui-media-icon">
                        <i class="mui-icons mui-icons-find2"></i>
                    </div>
                    <div class="mui-media-body" style="text-align: center;">信息披露</div>
                </a>
	            </li>
	            <li class="mui-table-view-cell mui-media mui-col-xs-4 mui-col-sm-3">
	                <a v-link="{ path: '/find/newmember'}" external>
	                    <div class="mui-media-icon">
	                        <i class="mui-icons mui-icons-find1"></i>
	                    </div>
	                    <div class="mui-media-body" style="text-align: center;">操作指南</div>
	                </a>
	            </li>
	           
	            <li class="mui-table-view-cell mui-media mui-col-xs-4 mui-col-sm-3">
	                <a v-link="{ path: '/find/aboutus'}" external>
	                    <div class="mui-media-icon">
	                        <i class="mui-icons mui-icons-find4"></i>
	                    </div>
	                    <div class="mui-media-body" style="text-align: center;">关于我们</div>
	                </a>
	            </li>
	            </ul>
                    
                </div>
            </div>
            
            <!-- <div class="mui-more-footer">
                <div class="mui-accumulated-trading">
                    <div class="mui-at-item">
                        <em>累计投资额</em>
                        <span><i v-html="totalCharge"></i> 元</span>
                    </div>
                    <div class="mui-at-item">
                        <em>为用户创造收益</em>
                        <span><i v-html="totalProfit"></i> 元</span>
                    </div>
                </div>
                <a href="/wealthm/information/index.html">查看更多</a>
                <p style="padding-bottom:0.5rem;">时间价值网 —— 每一秒都值得</p>
                <p>风险提示：市场有风险 投资需谨慎</p>
                <p>版权所有： 粤ICP备14094239号-1</p> 
                <p>公司地址：深圳市南山区科技园科技路9号桑达科技工业大厦二层</p>
            </div> -->
            
        </div>
        <div class="mui-web-end"><span>风险提示：网贷有风险，出借需谨慎</span></div>
    </div>
    

    <!-- 气泡 -->
    <div id="activity" data-view="hidden">
        <div class="mui-msg-icon"></div>
        <div class="mui-msg-wrap">
            <div class="mui-msg"><div class="mui-msg-in"><a class="msg-content" href="javascript:void(0);" data-url="/questions"></a></div></div>
        </div>
    </div>

    <router-view ></router-view>
</template>
<script>

    import "../../../static/js/hammer.min.js";
    import "../../../static/js/mui.activeity.js";
    import "../../../static/js/mui.tween.js";
    // import "../../../static/sass/hezhixian.scss";

    export default {
        data: function(){
            return {
                publicTips: false,
                bannerList: [],
                indicatorLength: 0,
                notice: [],
                totalCharge:0,
                totalProfit:0,
                totalDays: 0,
                ios : true,
                message: 0,
                userAssets: {},
                session: false
            }
        },
        created: function () {
            var _self = this, mobile = mui.localStorage.Get('username') || '';
            var s1 = new Date('2015/03/29'), s2 = new Date(), days = s2.getTime() - s1.getTime();
            _self.totalDays =  parseInt(days / (1000 * 60 * 60 * 24));
            timevalue.CheckAjax(timevalue.Api.assetsStatistical,function(json){
                if( json.code != '-1' ) {
                    _self.session = true;
                    _self.$parent.session = true;
                    _self.userAssets = json;
                }else{
                    //activityJs('#activity' ,'新手完成注册，即送8000体验金！','/wealthm/#!/register');
                }
            });
            $.getJSON('/wealthm/static/js/banner.json?v='+new Date().getTime(), function(data){
                
                //微信小程序中删除实话实说banner
                if(window.__wxjs_environment === 'miniprogram'){
                	for (var i=0;i<data.banner.length;i++) {
                		if(data.banner[i].href.indexOf('talk.html') !='-1'){
                			data.banner[i].weixin = false;
                		}
                	}
                	_self.indicatorLength = (data.banner.length - 4);
                }else{
                	_self.indicatorLength = (data.banner.length - 2);
                }
                _self.bannerList = data.banner;
                Vue.nextTick(function(){
                    _self.initEvent();
                    if(data.dialog != null){
                        if(!mui.localStorage.Get(data.dialog.tag)){
                            mui.activity({
                                image: data.dialog.image,
                                title: data.dialog.title,
                                content: data.dialog.content,
                                btn: data.dialog.btn || '',
                                callback: data.dialog.callback || ''
                            },function(e){
                                if(e.index == 1){
                                    if(data.dialog.fullscreen == '1'){
                                        mui.WebView.Screenfull(data.dialog.href);
                                    }else{
                                        top.window.location.href = data.dialog.href;
                                    }
                                }
                                mui.localStorage.Set(data.dialog.tag,true);
                            },data.dialog.theme);
                        }
                    }
                    if(data.custom != null){
                        if(!mui.localStorage.Get(data.custom.tag)){
                            if(data.custom.type == "all" || data.custom.type == "index"){
                                mui.dialog(data.custom.template,function(e){
                                    if(e.index == 1){
                                        if(data.custom.window != null){
                                            if(data.custom.windowTitle && window.plus){
                                                mui.WebView.Open({'href': data.custom.href,'title': data.custom.windowTitle},'default');
                                            }else if(data.custom.fullscreen){
                                                mui.WebView.Screenfull(data.custom.href);
                                            }else{
                                                top.window.location.href = data.custom.href;
                                            }
                                        }else{
                                            setTimeout(function(){
                                                Router.go({path: data.custom.href});
                                            },400)
                                        }
                                    }
                                    mui.localStorage.Set(data.custom.tag,true);
                                });
                            }
                        }
                    }
                });
            });
            // if(_self.session){
            //     timevalue.Ajax(timevalue.Api.assetsStatistical,function(json){
            //         _self.userAssets = json;
            //     });
            // }else{
            //     //判断用户是否还没登录
            //     timevalue.CheckAjax(timevalue.Api.userInfo,function(json){
            //          if( json.code != '-1' ) {
            //             _self.session = true;
            //             _self.$parent.session = true;
            //         }
            //     });
            // }
            // timevalue.Ajax(timevalue.Api.newsList,{'pageNo': '1','pageSize': '1','newsType':'news'},function(json){
            //     if(json.list.length){
            //         _self.notice = json.list;
            //     }
            // });
            //总收益
            timevalue.Ajax(timevalue.Api.siteInfo,function(json){
                _self.tweensMore(json.totalCharge,0,function(c){
                    _self.totalCharge = getCustomNumberByLength(c);
                });
                _self.tweensMore(json.totalProfit,0,function(p){
                    _self.totalProfit = getCustomNumberByLength(p, 2);
                });
                setTimeout(function(){
                    _self.updateMore(json);
                },600);
            });

            timevalue.userAjax(timevalue.Api.hasNewMessage,{'mobile': mobile},function(json){
                _self.message = json.messageNumber + json.newsNumber;
            })

            // if(!mui.localStorage.Get('IndexRechargeTip')){
            //     setTimeout(function(){
            //         _self.publicTips = true;
            //     },1000)
            // }
        },
        methods:{
            closeNotice: function(option){
                var _self = this;
                setTimeout(function(){
                    _self.publicTips = false;
                },400)
                mui.localStorage.Set('IndexRechargeTip', true);
            },
            tweensMore: function(newValue, oldValue, callback, fixed){
                var vm = this
                function animate (time) {
                requestAnimationFrame(animate)
                    TWEEN.update(time)
                }
                new TWEEN.Tween({ tweeningNumber: oldValue })
                .easing(TWEEN.Easing.Quadratic.Out)
                .to({ tweeningNumber: newValue }, 500)
                .onUpdate(function () {
                    callback(this.tweeningNumber.toFixed(fixed));
                })
                .start()
                animate()
            },
            updateMore: function(json){
                var _self = this;
                var siteTotalProfit = json.totalProfit;
                var siteProfitSecondPricePiece = json.profitPerSecond / 20;
                var refreshId3 = setInterval( function() 
                {
                    if(_self.ios){
                        siteTotalProfit = siteTotalProfit + siteProfitSecondPricePiece;
                        _self.totalProfit = getCustomNumberByLength(siteTotalProfit, 2);
                    }
                }, 50);
            },
            initEvent:function(){
                var _self = this;
                mui('.mui-slider').slider({ interval: 4000 });
                mui('.BannerTarget').on('tap','a',function(){
                    var el = this, fullscreen = (this.getAttribute('fullscreen') * 1);
                    if(window.plus){
                        if(fullscreen){
                            mui.WebView.Screenfull(el);
                        }else{
                            mui.WebView.Click(el,'default');
                        }
                    }else{
                        top.window.location.href = el.href;
                    }
                })
                if(mui.os.ios){
                    var Container = document.getElementById('Container');
                    Container.onscroll =function(){
                        (this.scrollTop < 0) ? _self.ios = false : _self.ios = true;
                    };
                }
                
                if(!mui.localStorage.Get('isGuide')){
                    mui.dialog('<div class="mui-bag-con mui-unopen"><a href="javascript:;" class="mui-popup-button mui-close-btn"><i class="mui-icon mui-icon-close"></i></a><div class="mui-bag-title"><span class="mui-fly-row">时间价值网送您</span><i></i></div><a href="javascript:;" onclick="$(this).parents(\'.mui-popup\').addClass(\'welcome\')" class="mui-bag-btn">立即打开<i></i></a></div><div class="mui-bag-con mui-open"><div class="mui-bag-ribbon"></div><div class="mui-bag-title"></div><div class="mui-bag-tip"><span  class="mui-fly-row">仅限新用户领取</span></div><a href="javascript:;" class="mui-popup-button mui-bag-btn">立即注册<i></i></a><ul class="mui-coupon-list"><li> <div class="mui-coupon-row"> <div class="mui-coupon-fix"> <div class="mui-coupon-number"><font>8000</font><span>体验金</span></div></div><div class="mui-coupon-flex"><div class="mui-coupon-desc mui-table-cell"><div class="mui-ellipsis">注册赠送<br/>体验时长：7天</div></div></div></div></li><li> <div class="mui-coupon-row"> <div class="mui-coupon-fix"> <div class="mui-coupon-number"><font>3.8%</font><span>加息券</span></div></div><div class="mui-coupon-flex"><div class="mui-coupon-desc mui-table-cell"><div class="mui-ellipsis">注册赠送<br/>加息时长：90天</div></div></div></div></li></ul></div>',function(e){
                        mui.localStorage.Set('isGuide',true);
                        if(e.index == 1){
                            setTimeout(function(){
                                Router.go({path: '/register'});
                            },300)
                        }
                    })
                }
            },
            calculate: function(){
                mui.loadCss('/wealthm/static/css/calculate.css?v='+new Date().getTime(),'calculateCss',function(){
                    mui.loadJs('/wealthm/static/js/mui.calculate.js?v='+new Date().getTime(),'calculateJs',function(){
                        $.Calculate({'rate':mui.siteRate});
                    })
                });
            },
            Contact: function(){
                var mobile = mui.localStorage.Get('username') || '';
                if(window.plus){
                    mui.WebView.Open({'title':'在线客服','href': 'http://sjjz.udesk.cn/im_client?web_plugin_id=23638&c_phone=' + mobile},'default');
                }else{
                    top.window.location.href = 'http://sjjz.udesk.cn/im_client?web_plugin_id=23638&c_phone=' + mobile;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// index.vue?3bfef07d